import type { UserAuth } from '@handover/shared-types';

const USER_ROLE_VALUES = new Set(['user', 'superUser', 'admin', 'superAdmin']);

export const getEffectiveUserRole = (userAuth?: UserAuth | null): UserAuth['role'] | undefined => {
  const claimRole = userAuth?.customClaims?.role;
  if (typeof claimRole === 'string' && USER_ROLE_VALUES.has(claimRole)) {
    return claimRole as UserAuth['role'];
  }

  return userAuth?.role;
};

export const hasRequiredRole = (
  userAuth: UserAuth | null | undefined,
  allowedRoles: ReadonlyArray<string>
): boolean => {
  const effectiveRole = getEffectiveUserRole(userAuth);
  return Boolean(effectiveRole && allowedRoles.includes(effectiveRole));
};

export const isPlatformOwner = (userAuth?: UserAuth | null): boolean =>
  userAuth?.customClaims?.platformOwner === true;
